module.exports = __webpack_public_path__ + "static/media/editar_amarelo.c4407c98.svg";